import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom/dist";
import { toast } from "react-toastify";

const ProtectedRoute = ({ file }) => {
  const { isLogin, meData } = useSelector((state) => state?.commonReducer);
  useEffect(() => {
    if (!isLogin) {
      toast.error("Please Login First");
    }
  }, [isLogin]);

  if (!isLogin) {
    return [<Navigate to="/" replace />];
  } else if (meData?.role === "admin") {
    return [<Navigate to="/admin/dashboard" replace />];
  } else {
    return file;
  }
};

export default ProtectedRoute;
